import { IOneTimePaymentItem, IPlan } from '../model';
import { useMemo } from 'react';
import { defaultSport } from '../constants';

export const useSports = (plans: IPlan[], onePaymentItems: IOneTimePaymentItem[], setSelectedSport: (sport: string) => void, sport: string) => {
  return useMemo(() => {
    let sports: string[] = [];
    plans.forEach(plan => {
      sports = [...sports, plan.display.sport_category];
    });

    onePaymentItems.forEach(item => {
      sports = [...sports, item.display.sport_category];
    });

    let array = Array.from(new Set(sports));

    if (Array.isArray(array) && !array.includes(sport) && plans.length) {
      if (array.includes(defaultSport)) {
        setSelectedSport(defaultSport);
      }
      if (array[0]) setSelectedSport(array[0]);
    }

    // Need to filter by window.tabsOrdering
    if(Array.isArray( window.tabsOrdering)) {
      array = array.filter(sport => window.tabsOrdering.includes(sport));
      array.sort((plan1, plan2) => window.tabsOrdering.indexOf(plan1) - window.tabsOrdering.indexOf(plan2));
    }
    return array;
  }, [plans, onePaymentItems])
}
